import style from './index.module.css';
import { Children } from '../types';
import Close from '../../static/images/close.svg';
import { useLockBodyScroll } from '../../utils/customHooks';
import React, { useEffect, useState } from 'react';
import { isServer } from '../../utils/utils';

type ModalProps = {
    closeModal: () => void;
} & Children;

export const Modal = ({ children, closeModal }: ModalProps) => {
    // Call hook to lock body scroll
    useLockBodyScroll();
    const [isVisible, setIsVisible] = useState(true);
    const fadeOutModal = () => {
        setIsVisible(false);
        setTimeout(closeModal, 250);
    };
    const handleEscapePress = ({ key }: KeyboardEvent) => {
        if (key === 'Escape') {
            fadeOutModal();
        }
    };
    // Add event listeners
    useEffect(() => {
        if (isServer()) {
            return undefined;
        }
        window.addEventListener('keydown', handleEscapePress);
        // Remove event listeners on cleanup
        return () => {
            window.removeEventListener('keydown', handleEscapePress);
        };
    }, []); // Empty array ensures that effect is only run on mount and unmount
    return (
        <div className={`${style.modalWrapper} ${isVisible ? style.visible : ''}`}>
            {children}
            <button type="button" onClick={fadeOutModal} className={style.closeBtn} aria-label="Close">
                <Close />
            </button>
        </div>
    );
};
